import { render } from "./accrodion.vue?vue&type=template&id=2681b350"
import script from "./accrodion.vue?vue&type=script&lang=js"
export * from "./accrodion.vue?vue&type=script&lang=js"

import "./accrodion.vue?vue&type=style&index=0&id=2681b350&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__